<template>
    <div class="mPage">
        <div class="top">
            <img src="../img/m/m_logo.png" alt="" class="logo">
            <span class="title">{{ $t("message.picture") }}</span>
            <slot></slot>
        </div>
        <div class="content" @click="toHideTip()">
            <div class="onePicureCon" v-if="isShowModal">
                
                <swiper :options="swiperOption" ref="pictureSwiper" class="imgContainer" v-if="oneAlbumList.length">
                    <swiper-slide  v-for="(item, index) in oneAlbumList" :key="index" class="container">
                        <div class="item">
                            <img :src="'http://conference2019.hanban.org'+'/upload/'+item.img_url" alt=""  v-on:load="loadImg(index, $event)"
                            :class="{ 'toWidth': item['toWidth'] == true}">  
                        </div>             
                    </swiper-slide>   
                    <!-- <div class="swiper-pagination customPag"  slot="pagination"></div> -->
                </swiper>
                
            </div>
            <div class="swipeTip" v-if="isShowTip">
                <div class="tipCon">
                    <div class="tipTitle">
                        <span>向左滑动</span>
                        <span>Swipe left</span>
                    </div>
                    
                    <img src="../img/m/swipe_tip.png" alt="">
                </div>
                
                
            </div>
        </div>
        <img src="../img/m/arrow_down.png" alt="" class="arrowDown">
    </div>
</template>

<script>
export default {
    name: 'm_picture',
    components: {
        
    },
    data: function () {
        return {
            swiperOption: {
                loop : true
                },
                
            recommendPictureList: [],
            isShowModal: true,
            oneAlbumList: [],
            isShowTip: true
        }
    },
    computed: {
        pictureSwiper() {
            return this.$refs.pictureSwiper.swiper
            
        },
        recommendPictureList_5 () {
            return this.recommendPictureList.slice(0,5)
        }
    },
    methods: {
    // 根据图片宽高比动态显示不同样式
    loadImg (i, e) {
        if(e.target.naturalWidth<=e.target.naturalHeight){
            this.$set(this.oneAlbumList[i], 'toWidth', true)
        }else {
            this.$set(this.oneAlbumList[i], 'toWidth', false)
        }
    },
    close () {
        this.isShowModal = false
    },
    showAllPic (id) {
        this.isShowModal = true
        this.$utils
            .get("album/api/getAllPicsList", {
                lang: "cn",
                album_id: id
            })
            .then(res => {
                this.oneAlbumList = res.data.data.list
            });
    },
    toDetail(item) {
        window.open(item)
    },
    getPicureList() {
      this.$utils
        .get("album/api/getAllRecommendsList", {
            lang: "cn",
            type: 2
        })
        .then(res => {
            this.recommendPictureList = res.data.data.list
            this.showAllPic(this.recommendPictureList[0].target_id)
        });
    },
    showTip () {
        var tip = localStorage.getItem('tip')
        console.log(tip)
        if(tip){
            this.isShowTip = false
        }
    },
    toHideTip () {
        if(this.isShowTip){
            this.isShowTip = false
            localStorage.setItem('tip', false)
        }
    }

  },
    watch: {

    },
  mounted() {
      this.getPicureList()
      this.showTip()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.mPage {
    width: 100%;
    height: 100%;
    overflow: hidden;
    .top {
        height: 1.4rem;
        line-height: 1.4rem;
        position: relative;
        .logo {
            width: 1.27rem;
            margin: auto 0.34rem;
            vertical-align: middle;
        }
        .title {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            width: 1.93rem;
            display: inline-block;
            text-align: center;
            font-size: 0.46rem;
            white-space: nowrap;
            color: #f3bc65;

        }
        .menu {
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto;
            right: 0.34rem;
            width: 0.51rem;
            vertical-align: middle;
        }
    }
    .content {
        height: calc(100% - 1.4rem);
        line-height: calc(100% - 1.4rem);
        background-image: url(../img/m/m_picture_bg.png);
        background-size: contain;
        background-repeat: no-repeat;
        text-align: center;
        position: relative;
        z-index: 1;
        .pictureCon {
            white-space: nowrap;
            overflow-x: auto;
            position: absolute;
            top: 55%;
            margin-top: -50%;
        }
        .pictureItem {
            display: inline-block;
            vertical-align: middle;
            width: 87%;
            margin: auto 0.2rem auto 0.25rem;
            img {
                width: 100%;
            }
            
        }
        .onePicureCon {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: calc(100% - 1.4rem);
            
            .top {
                height: 1rem;
                line-height: 1rem;
                z-index: 5;
                img {
                    position: absolute;
                    right: 0.2rem;
                    top: 0.3rem;
                    width: 0.5rem;
                }
            }
            .imgContainer {
                position: absolute;
                top: 0;
                width: 100%;
                height: 100%;
                .container {
                    width: 100%;
                    height: 100%;
                    .item {
                        width: 100%;
                        height: 100%;
                        overflow: hidden;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        
                    img {
                        width: 100%;
                        height: auto;
                    }
                    .toWidth {
                        max-height: 100%;
                        max-width: 100%;
                        width: initial;
                        
                    }

                    }
                }
                .customPag {
                    left: 0;
                    right: 0;
                    margin: auto;
                    bottom: 2rem;
                    color: #fff;
                }
            }
        }
        .swipeTip {
            position: absolute;
            bottom: 2.4rem;
            left: 0;
            right: 0;
            width: 3.2rem;
            height: 2rem;
            margin: auto;
            z-index: 6;
            .tipCon {
                position: absolute;
                // width: 100%;
                height: 100%;
                white-space: nowrap;
                .tipTitle {
                    display: inline-block;
                    span {
                        display: block;
                        color: #fff;
                        font-size: 0.41rem;
                        opacity: 0.5;
                        height: 1.2em;
                    }
                }
                
                img {
                    width: 1.85rem;
                    position: relative;
                    top: 0.2rem;
                    animation: toXLeft 0.8s infinite alternate-reverse;
                }
                
            }
            
            
        }


    }
    .arrowDown {
        position: absolute;
        bottom: 0.48rem;
        left: 0;
        right: 0;
        width: 0.28rem;
        margin: auto;
        animation: rotation 0.8s infinite alternate-reverse;
    }
    .secondPage {
        position: absolute;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        background-image: url(../img/m/m_bg.png);
        background-size: cover;
    }
}
@-webkit-keyframes rotation {
    from {transform: translateY(0)}
    to   {transform: translateY(5px)}
}
@-webkit-keyframes toXLeft {
    from {transform: translateX(-0.2rem)}
    to   {transform: translateX(0)}
}
</style>
